import { render } from "./Periodic.vue?vue&type=template&id=1a103fd4"
import script from "./Periodic.vue?vue&type=script&lang=js"
export * from "./Periodic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__